import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'params'
})
export class ParamsPipe implements PipeTransform {
    transform(value: string, args: string[]): string {
        for (const index in args) {
            value = value?.replace(`{${index}}`, args[index]);
        }
        return value;
    }
}
